/**
 * Suodatinvalitsin – LuxuryShowers.fi
 * Aihio Digital
 * ============================================================
 *
 * Vaiheittainen valitsin, joka ohjaa asiakkaan oikeisiin
 * suodatintuotteisiin.
 *
 * Rakenne:
 *  - TREE: koko valintapuun rakenne, kysymykset ja lopputulokset
 *  - Jokainen lopputulos osoittaa Shopify-kokoelmaan (collectionUrl).
 *    Tulossivu näyttää kokoelman kaikki tuotteet, jotka haetaan
 *    osoitteesta /collections/{handle}/products.json. Tuotteiden
 *    lisäys, poisto ja järjestys hoidetaan siis Shopify Adminissa.
 *  - Kokoelmat välimuistitetaan, jotta sama kokoelma ei lataudu kahdesti
 *
 * Uuden suihkumallin lisääminen:
 *  1) Lisää uusi haara TREE-objektiin (esim. result_uusimalli)
 *  2) Lisää viittaus haaraan vastaavaan kysymykseen (options-taulukkoon)
 *  3) Tarkista että collectionUrl osoittaa oikeaan kokoelmaan
 */

(function () {
  'use strict';

  // ---------------------------------------------------------
  // Valintapuun data
  // ---------------------------------------------------------
  const TREE = {
    start: {
      step: 1,
      question: 'Mikä suihku sinulla on?',
      subtitle: 'Käännä suihkun pää ylösalaisin ja katso, mitä suihkulevyssä lukee.',
      options: [
        {
          label: 'Aromica',
          hint: 'Suihkulevyssä iso A-kirjain keskellä.',
          image: 'https://cdn.shopify.com/s/files/1/0875/3414/1734/files/Aromica_suodattimen_valinta.jpg?v=1780920290&width=600',
          next: 'aromica'
        },
        {
          label: 'KNTEC',
          hint: 'Suihkulevyssä lukee KNTEC.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/AS-9000-suihkulevy.jpg?v=1717498589&width=600',
          next: 'kntec'
        }
      ]
    },

    aromica: {
      step: 2,
      question: 'Mikä Aromica-malli?',
      subtitle: 'Mittaa suihkun pään halkaisija tai katso muodosta.',
      options: [
        {
          label: 'ARO800',
          hint: 'Halkaisija 8 cm, suihkun pään takaosa on tasainen.',
          image: 'https://cdn.shopify.com/s/files/1/0875/3414/1734/files/ARO800_tasainen_pieni.jpg?v=1773765970',
          next: 'result_aro800'
        },
        {
          label: 'ARO900 / PURA900',
          hint: 'Halkaisija 9 cm, suihkun pään takaosa on kupera.',
          image: 'https://cdn.shopify.com/s/files/1/0875/3414/1734/files/ARO900_sivuprofiili.jpg?v=1773765385',
          next: 'result_aro900'
        },
        {
          label: 'Aromica LUXE',
          hint: 'Halkaisija 10 cm, ruusukultainen reunus, levyssä lukee LUXE.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/AROLUXE1080-marmori.jpg?v=1763676934&width=5000',
          next: 'result_luxe'
        }
      ]
    },

    kntec: {
      step: 2,
      question: 'Mikä KNTEC-malli?',
      subtitle: 'Tunnista suihku alla olevista vihjeistä.',
      options: [
        {
          label: 'AS-9000',
          hint: 'Aroma Sense AS-9000, suihkulevyssä lukee KNTEC.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/AS-9000-Aroma-Sense-high-pressure-shower-head-1.jpg?v=1719513535&width=5000',
          next: 'result_as9000'
        },
        {
          label: 'SJW / WS800',
          hint: 'Kulmikas suihku, 8 cm leveä, muistuttaa vanhaa lankapuhelinta.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/SJW-suihkup.jpg?v=1723291523&width=450',
          next: 'result_sjw'
        },
        {
          label: 'Prestige',
          hint: 'Levyssä lukee Prestige ja Aroma Sense, 9,5 cm leveä.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/AS-Prestige-suihkulevy_84b5869f-0e60-4ffe-b35d-dced4ea60a07.jpg?v=1719218445&width=600',
          next: 'result_prestige'
        },
        {
          label: 'AS-701',
          hint: 'Varressa lukee Aroma Sense, halkaisija 11,5 cm, raskas.',
          image: 'https://luxuryshowers.fi/cdn/shop/files/AS-701-suihkulevy_eb290f88-ae91-4fb6-a3a4-7dabca4ae09d.jpg?v=1719218281&width=600',
          next: 'result_as701'
        }
      ]
    },

    // ---------------------------------------------------------
    // Lopputulokset – jokainen osoittaa kokoelmaan (collectionUrl)
    // Tulossivu näyttää kokoelman kaikki tuotteet, jotka haetaan
    // automaattisesti /collections/{handle}/products.json -rajapinnasta.
    // ---------------------------------------------------------
    result_aro800: {
      step: 3,
      title: 'ARO800 -suihku',
      description: 'ARO800 (Aromica) -suihkuun sopivat seuraavat suodattimet ja antibakteerikuulat. Suosittelemme aloittamaan ACF-aktiivihiilisuodattimesta, jos haluat suodattaa klooria ja metalleja.',
      image: 'https://cdn.shopify.com/s/files/1/0875/3414/1734/files/ARO800_tasainen_pieni.jpg?v=1773765970',
      collectionUrl: '/collections/suodattimet-sisaltosivu2'
    },
    result_aro900: {
      step: 3,
      title: 'ARO900 / PURA900 -suihku',
      description: 'ARO900-suihkuun sopivat suodattimet. Mikrokuitusuodatin sopii kalkki- ja metalliongelmien lievittämiseen, ACF tehokkaampaan suodatukseen.',
      image: 'https://cdn.shopify.com/s/files/1/0875/3414/1734/files/ARO900_sivuprofiili.jpg?v=1773765385',
      collectionUrl: '/collections/suihkusuodatin-sisaltosivu'
    },
    result_luxe: {
      step: 3,
      title: 'Aromica LUXE -suihku',
      description: 'Aromica LUXE -suihkuun (10 cm leveä, ruusukultainen reunus) sopivat omat erilliset suodattimensa. Tehosuodatin on tehokkain valinta kalkille ja metalleille.',
      image: 'https://luxuryshowers.fi/cdn/shop/files/AROLUXE1080-marmori.jpg?v=1763676934&width=5000',
      collectionUrl: '/collections/suodattimet-sisaltosivu4'
    },
    result_as9000: {
      step: 3,
      title: 'Aroma Sense AS-9000 -suihku',
      description: 'AS-9000-suihkuun sopivat seuraavat suodattimet. Mikrokuitusuodatin perussuodatukseen, ACF tuoksuihin ja klooriin, Pure Rain tehokkaimpaan kalkin ja metallin poistoon.',
      image: 'https://luxuryshowers.fi/cdn/shop/files/AS-9000-Aroma-Sense-high-pressure-shower-head-1.jpg?v=1719513535&width=5000',
      collectionUrl: '/collections/suodattimet-sisaltosivu2'
    },
    result_sjw: {
      step: 3,
      title: 'SJW / WS800 -suihku',
      description: 'SJW- ja WS800-suihkuihin sopivat samat suodattimet. ACF on suositeltavin, jos hankit suihkun nimenomaan suodattamisen takia.',
      image: 'https://luxuryshowers.fi/cdn/shop/files/SJW-suihkup.jpg?v=1723291523&width=450',
      collectionUrl: '/collections/suodattimet-sisaltosivu6'
    },
    result_prestige: {
      step: 3,
      title: 'AS-Prestige -suihku',
      description: 'AS-Prestige -suihku on poistunut valikoimasta, mutta suodattimet ovat edelleen saatavilla. Pure Rain on tehokkain vaihtoehto.',
      image: 'https://luxuryshowers.fi/cdn/shop/files/AS-Prestige-suihkulevy_84b5869f-0e60-4ffe-b35d-dced4ea60a07.jpg?v=1719218445&width=600',
      collectionUrl: '/collections/suodattimet-sisaltosivu5'
    },
    result_as701: {
      step: 3,
      title: 'Aroma Sense AS-701 -suihku',
      description: 'AS-701-suihkuun (halkaisija 11,5 cm) sopivat omat erilliset suodattimensa. Pure Rain on tehokkain kalkin ja metallien poistoon.',
      image: 'https://luxuryshowers.fi/cdn/shop/files/AS-701-suihkulevy_eb290f88-ae91-4fb6-a3a4-7dabca4ae09d.jpg?v=1719218281&width=600',
      collectionUrl: '/collections/suodattimet-sisaltosivu3'
    }
  };

  const I18N = {
    fi: {
      step: 'Vaihe',
      back: '← Takaisin',
      unsure: 'Etkö ole varma kumpi se on?',
      contactSupport: 'Ota yhteyttä asiakaspalveluun',
      helpSuffix: 'niin autamme tunnistamaan suihkusi.',
      yourShower: 'Sinun suihkusi:',
      suitableFilters: 'Sinulle sopivat suodattimet',
      restart: 'Aloita alusta',
      fineprintPrefix: 'Jos olet epävarma valinnasta tai et tunnista suihkuasi,',
      fineprintLink: 'ota yhteyttä',
      fineprintSuffix: 'niin autamme.',
      loadError: 'Tuotetietojen lataus epäonnistui.',
      collectionLink: 'Siirry tuotekokoelmaan',
      addToCart: 'Lisää ostoskoriin',
      soldOut: 'Loppu varastosta',
      adding: 'Lisätään...',
      added: '✓ Lisätty ostoskoriin',
      retry: 'Yritä uudelleen'
    },
    en: {
      step: 'Step',
      back: '← Back',
      unsure: 'Not sure which one it is?',
      contactSupport: 'Contact customer service',
      helpSuffix: 'and we will help identify your shower.',
      yourShower: 'Your shower:',
      suitableFilters: 'Filters that fit your shower',
      restart: 'Start over',
      fineprintPrefix: 'If you are unsure or cannot identify your shower,',
      fineprintLink: 'contact us',
      fineprintSuffix: 'and we will help.',
      loadError: 'Product information could not be loaded.',
      collectionLink: 'Open the product collection',
      addToCart: 'Add to cart',
      soldOut: 'Sold out',
      adding: 'Adding...',
      added: '✓ Added to cart',
      retry: 'Try again'
    }
  };

  const TREE_TRANSLATIONS = {
    en: {
      start: {
        question: 'Which shower do you have?',
        subtitle: 'Turn the shower head upside down and check what is written on the spray plate.',
        options: [
          { label: 'Aromica', hint: 'A large letter A in the middle of the spray plate.' },
          { label: 'KNTEC', hint: 'The spray plate says KNTEC.' }
        ]
      },
      aromica: {
        question: 'Which Aromica model?',
        subtitle: 'Measure the shower head diameter or compare the shape.',
        options: [
          { label: 'ARO800', hint: '8 cm diameter, flat back on the shower head.' },
          { label: 'ARO900 / PURA900', hint: '9 cm diameter, rounded back on the shower head.' },
          { label: 'Aromica LUXE', hint: '10 cm diameter, rose-gold rim, LUXE on the spray plate.' }
        ]
      },
      kntec: {
        question: 'Which KNTEC model?',
        subtitle: 'Identify your shower using the hints below.',
        options: [
          { label: 'AS-9000', hint: 'Aroma Sense AS-9000, with KNTEC on the spray plate.' },
          { label: 'SJW / WS800', hint: 'Angular shower, 8 cm wide, shaped a bit like an old telephone handset.' },
          { label: 'Prestige', hint: 'The plate says Prestige and Aroma Sense, 9.5 cm wide.' },
          { label: 'AS-701', hint: 'Aroma Sense on the handle, 11.5 cm diameter, heavier build.' }
        ]
      },
      result_aro800: {
        title: 'ARO800 shower',
        description: 'These filters and antibacterial balls fit the ARO800 (Aromica) shower. We recommend starting with the ACF activated carbon filter if you want to filter chlorine and metals.'
      },
      result_aro900: {
        title: 'ARO900 / PURA900 shower',
        description: 'These filters fit the ARO900 shower. The microfiber filter helps with limescale and metals, while ACF gives stronger filtration.'
      },
      result_luxe: {
        title: 'Aromica LUXE shower',
        description: 'Aromica LUXE shower (10 cm wide, rose-gold rim) uses its own filters. The high-performance filter is the strongest choice for limescale and metals.'
      },
      result_as9000: {
        title: 'Aroma Sense AS-9000 shower',
        description: 'These filters fit the AS-9000 shower. Microfiber is good for basic filtration, ACF for odors and chlorine, and Pure Rain for the strongest limescale and metal reduction.'
      },
      result_sjw: {
        title: 'SJW / WS800 shower',
        description: 'SJW and WS800 showers use the same filters. ACF is the recommended option if filtration is the main reason you bought the shower.'
      },
      result_prestige: {
        title: 'AS-Prestige shower',
        description: 'The AS-Prestige shower is discontinued, but compatible filters are still available. Pure Rain is the strongest option.'
      },
      result_as701: {
        title: 'Aroma Sense AS-701 shower',
        description: 'The AS-701 shower (11.5 cm diameter) uses its own filters. Pure Rain is the strongest option for limescale and metals.'
      }
    }
  };

  // ---------------------------------------------------------
  // Sovelluksen tila ja DOM-elementit
  // ---------------------------------------------------------
  const TOTAL_STEPS = 3;
  const SKELETON_COUNT = 4;
  const collectionCache = new Map();
  const instances = new WeakMap();

  // ---------------------------------------------------------
  // Apufunktiot
  // ---------------------------------------------------------
  function escapeHTML(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getText(ctx, key) {
    const locale = ctx.settings.locale === 'en' ? 'en' : 'fi';
    return (I18N[locale] && I18N[locale][key]) || I18N.fi[key] || '';
  }

  function getNode(ctx, nodeKey) {
    const source = TREE[nodeKey];
    const locale = ctx.settings.locale === 'en' ? 'en' : 'fi';
    const translation = TREE_TRANSLATIONS[locale] && TREE_TRANSLATIONS[locale][nodeKey];
    if (!translation) return source;

    const node = Object.assign({}, source, translation);
    if (source.options && translation.options) {
      node.options = source.options.map(function (option, index) {
        return Object.assign({}, option, translation.options[index] || {});
      });
    }
    return node;
  }

  function getRouteRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    // Shopifyn /products/{handle}.js palauttaa hinnan sentteinä
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  // Muuntaa /products.json -muotoisen tuotteen renderöinnin tarvitsemaan muotoon.
  // Hinnat tulevat merkkijonoina euroina ("20.00"), joten ne muutetaan senteiksi.
  function normalizeProduct(product) {
    const variants = product.variants || [];
    if (variants.length === 0) return null;
    const variant = variants.find(function (v) { return v.available; }) || variants[0];
    const prices = variants.map(function (v) { return Math.round(parseFloat(v.price) * 100); });
    return {
      title: product.title,
      url: getRouteRoot() + 'products/' + product.handle,
      image: product.images && product.images[0] ? product.images[0].src : '',
      price: Math.min.apply(null, prices),
      variantId: variant.id,
      available: variant.available
    };
  }

  async function fetchCollectionProducts(collectionUrl) {
    if (collectionCache.has(collectionUrl)) return collectionCache.get(collectionUrl);
    try {
      const path = collectionUrl.replace(/^\//, '').replace(/\/$/, '');
      const res = await fetch(getRouteRoot() + path + '/products.json?limit=250');
      if (!res.ok) throw new Error('Kokoelmaa ei löytynyt: ' + collectionUrl);
      const data = await res.json();
      const products = (data.products || []).map(normalizeProduct).filter(Boolean);
      collectionCache.set(collectionUrl, products);
      return products;
    } catch (err) {
      console.warn('[Suodatinvalitsin] Kokoelman lataus epäonnistui:', collectionUrl, err);
      return [];
    }
  }

  // ---------------------------------------------------------
  // Renderöinti
  // ---------------------------------------------------------
  function renderStepbar(ctx, step) {
    let html = '';
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      const cls = i < step ? 'sv-dot sv-dot--done' : i === step ? 'sv-dot sv-dot--active' : 'sv-dot';
      html += '<div class="' + cls + '"></div>';
      if (i < TOTAL_STEPS) html += '<div class="sv-line"></div>';
    }
    html += '<span class="sv-step-text">' + getText(ctx, 'step') + ' ' + step + ' / ' + TOTAL_STEPS + '</span>';
    ctx.stepbar.innerHTML = html;
  }

  function renderQuestion(ctx, nodeKey) {
    const node = getNode(ctx, nodeKey);
    renderStepbar(ctx, node.step);

    const backHtml = ctx.history.length > 1
      ? '<button type="button" class="sv-back" data-action="back">' + escapeHTML(getText(ctx, 'back')) + '</button>'
      : '';

    const cardsHtml = node.options.map(function (opt) {
      return (
        '<button type="button" class="sv-card" data-next="' + escapeHTML(opt.next) + '">' +
          '<img src="' + escapeHTML(opt.image) + '" alt="' + escapeHTML(opt.label) + '" loading="lazy" />' +
          '<div class="sv-card-title">' + escapeHTML(opt.label) + '</div>' +
          '<div class="sv-card-hint">' + escapeHTML(opt.hint) + '</div>' +
        '</button>'
      );
    }).join('');

    const showHelp = node.step === 1 && ctx.settings.showHelp;
    const helpHtml = showHelp
      ? '<div class="sv-help">' + escapeHTML(getText(ctx, 'unsure')) + ' ' +
        '<a href="' + escapeHTML(ctx.settings.helpUrl) + '">' + escapeHTML(getText(ctx, 'contactSupport')) + '</a> ' +
        escapeHTML(getText(ctx, 'helpSuffix')) + '</div>'
      : '';

    ctx.content.innerHTML =
      backHtml +
      '<h2 class="sv-h">' + escapeHTML(node.question) + '</h2>' +
      '<p class="sv-sub">' + escapeHTML(node.subtitle) + '</p>' +
      '<div class="sv-grid">' + cardsHtml + '</div>' +
      helpHtml;
  }

  async function renderResult(ctx, nodeKey) {
    const node = getNode(ctx, nodeKey);
    renderStepbar(ctx, node.step);

    let skeletonHtml = '';
    for (let i = 0; i < SKELETON_COUNT; i++) {
      skeletonHtml += '<div class="sv-product sv-product--loading"><div class="sv-product-skeleton"></div></div>';
    }

    ctx.content.innerHTML =
      '<button type="button" class="sv-back" data-action="back">' + escapeHTML(getText(ctx, 'back')) + '</button>' +
      '<div class="sv-result-head">' +
        '<img src="' + escapeHTML(node.image) + '" alt="' + escapeHTML(node.title) + '" loading="lazy" />' +
        '<div>' +
          '<h3>' + escapeHTML(getText(ctx, 'yourShower')) + ' ' + escapeHTML(node.title) + '</h3>' +
          '<p>' + escapeHTML(node.description) + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="sv-products-title">' + escapeHTML(getText(ctx, 'suitableFilters')) + '</div>' +
      '<div class="sv-products" data-sv-products>' + skeletonHtml + '</div>' +
      '<div class="sv-actions">' +
        '<button type="button" class="sv-btn-secondary" data-action="restart">' + escapeHTML(getText(ctx, 'restart')) + '</button>' +
      '</div>' +
      '<p class="sv-fineprint">' + escapeHTML(getText(ctx, 'fineprintPrefix')) + ' ' +
      '<a href="' + escapeHTML(ctx.settings.helpUrl) + '">' + escapeHTML(getText(ctx, 'fineprintLink')) + '</a> ' +
      escapeHTML(getText(ctx, 'fineprintSuffix')) + '</p>';

    const productsEl = ctx.content.querySelector('[data-sv-products]');
    const products = await fetchCollectionProducts(node.collectionUrl);

    if (!productsEl || ctx.history[ctx.history.length - 1] !== nodeKey) return;

    if (products.length === 0) {
      productsEl.innerHTML =
        '<div class="sv-product-error">' + escapeHTML(getText(ctx, 'loadError')) + ' ' +
        '<a href="' + escapeHTML(node.collectionUrl) + '">' + escapeHTML(getText(ctx, 'collectionLink')) + '</a></div>';
      return;
    }

    productsEl.innerHTML = products.map(function (product) {
      const image = product.image;

      const btnHtml = product.available
        ? '<button type="button" class="sv-btn" data-action="add-to-cart" ' +
          'data-variant-id="' + product.variantId + '" data-product-title="' + escapeHTML(product.title) + '">' +
          '<span class="sv-btn-text">' + escapeHTML(getText(ctx, 'addToCart')) + '</span>' +
          '</button>'
        : '<button type="button" class="sv-btn sv-btn--disabled" disabled>' + escapeHTML(getText(ctx, 'soldOut')) + '</button>';

      const imgHtml = image
        ? '<a href="' + escapeHTML(product.url) + '" class="sv-product-img"><img src="' + escapeHTML(image) + '" alt="' + escapeHTML(product.title) + '" loading="lazy" /></a>'
        : '<div class="sv-product-img sv-product-img--placeholder"></div>';

      return (
        '<div class="sv-product">' +
          imgHtml +
          '<a href="' + escapeHTML(product.url) + '" class="sv-product-name">' + escapeHTML(product.title) + '</a>' +
          '<div class="sv-product-price">' + formatMoney(product.price) + '</div>' +
          btnHtml +
        '</div>'
      );
    }).join('');
  }
  // ---------------------------------------------------------
  // Navigointi
  // ---------------------------------------------------------
  function selectOption(ctx, nextKey) {
    ctx.history.push(nextKey);
    if (nextKey.indexOf('result_') === 0) {
      renderResult(ctx, nextKey);
    } else {
      renderQuestion(ctx, nextKey);
    }
    scrollToTop(ctx);
  }

  function goBack(ctx) {
    if (ctx.history.length > 1) {
      ctx.history.pop();
      const prev = ctx.history[ctx.history.length - 1];
      if (prev.indexOf('result_') === 0) renderResult(ctx, prev);
      else renderQuestion(ctx, prev);
      scrollToTop(ctx);
    }
  }

  function restart(ctx) {
    ctx.history = ['start'];
    renderQuestion(ctx, 'start');
    scrollToTop(ctx);
  }

  function scrollToTop(ctx) {
    const rect = ctx.root.getBoundingClientRect();
    const offset = window.pageYOffset + rect.top - 80;
    window.scrollTo({ top: Math.max(offset, 0), behavior: 'smooth' });
  }

  // ---------------------------------------------------------
  // Ajax cart
  // ---------------------------------------------------------
  async function addToCart(ctx, btn) {
    const variantId = btn.getAttribute('data-variant-id');
    const productTitle = btn.getAttribute('data-product-title');
    const textEl = btn.querySelector('.sv-btn-text');
    const originalText = textEl.textContent;

    btn.disabled = true;
    btn.classList.add('sv-btn--loading');
    textEl.textContent = getText(ctx, 'adding');

    try {
      const res = await fetch(getRouteRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      });

      if (!res.ok) {
        const errorData = await res.json().catch(function () { return {}; });
        throw new Error(errorData.description || 'Lisäys koriin epäonnistui');
      }

      // Päivitä korin laskuri ja triggeröi teeman omat eventit
      await updateCartUI();

      btn.classList.remove('sv-btn--loading');
      btn.classList.add('sv-btn--added');
      textEl.textContent = getText(ctx, 'added');

      // Jos asetuksissa on valittu ohjaus koriin, mene sinne
      if (ctx.settings.cartRedirect) {
        setTimeout(function () { window.location.href = '/cart'; }, 600);
        return;
      }

      setTimeout(function () {
        btn.classList.remove('sv-btn--added');
        textEl.textContent = originalText;
        btn.disabled = false;
      }, 2200);
    } catch (err) {
      console.error('[Suodatinvalitsin] Cart error:', err);
      btn.classList.remove('sv-btn--loading');
      btn.classList.add('sv-btn--error');
      textEl.textContent = getText(ctx, 'retry');
      setTimeout(function () {
        btn.classList.remove('sv-btn--error');
        textEl.textContent = originalText;
        btn.disabled = false;
      }, 2500);
    }
  }

  async function updateCartUI(cartData) {
    // Hae päivitetty korin tila
    try {
      const cart = cartData || await fetch(getRouteRoot() + 'cart.js').then(function (res) { return res.json(); });

      // Päivitä korin laskuri (yritetään useita teemoissa käytettyjä luokkanimiä)
      const countSelectors = [
        '[data-cart-count]',
        '.cart-count-bubble span',
        '.cart-count',
        '#cart-icon-bubble span',
        '.header__cart-count'
      ];
      countSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          if (el.hasAttribute('data-cart-count')) {
            el.setAttribute('data-cart-count', cart.item_count);
          }
          el.textContent = cart.item_count;
        });
      });
      document.dispatchEvent(new CustomEvent('on:cart:change', { detail: cart, bubbles: true, cancelable: false }));
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: null }, bubbles: true, cancelable: false }));
      }, 120);
    } catch (err) {
      console.warn('[Suodatinvalitsin] Cart UI -päivitys epäonnistui:', err);
    }
  }

  // ---------------------------------------------------------
  // Event delegation – yksi listener koko valitsimelle
  // ---------------------------------------------------------
  function handleClick(e) {
    const target = e.target.closest('[data-action], [data-next]');
    if (!target) return;

    const root = target.closest('[data-suodatinvalitsin]');
    const ctx = root ? instances.get(root) : null;
    if (!ctx) return;

    if (target.hasAttribute('data-next')) {
      e.preventDefault();
      selectOption(ctx, target.getAttribute('data-next'));
      return;
    }

    const action = target.getAttribute('data-action');
    if (action === 'back') { e.preventDefault(); goBack(ctx); }
    else if (action === 'restart') { e.preventDefault(); restart(ctx); }
    else if (action === 'add-to-cart') { e.preventDefault(); addToCart(ctx, target); }
  }

  // ---------------------------------------------------------
  // Init
  // ---------------------------------------------------------
  function initRoot(root) {
    if (!root || root.dataset.svInitialized === 'true') return;

    const stepbar = root.querySelector('[data-sv-stepbar]');
    const content = root.querySelector('[data-sv-content]');
    if (!stepbar || !content) return;

    const ctx = {
      root: root,
      stepbar: stepbar,
      content: content,
      history: ['start'],
      settings: {
        locale: (root.getAttribute('data-locale') || 'fi').split('-')[0],
        cartRedirect: root.getAttribute('data-cart-redirect') === 'true',
        helpUrl: root.getAttribute('data-help-url') || '/pages/ota-yhteytta',
        showHelp: root.getAttribute('data-show-help') !== 'false'
      }
    };

    instances.set(root, ctx);
    root.dataset.svInitialized = 'true';
    root.addEventListener('click', handleClick);
    renderQuestion(ctx, 'start');
  }

  function init(scope) {
    const currentScope = scope || document;
    if (currentScope.matches && currentScope.matches('[data-suodatinvalitsin]')) {
      initRoot(currentScope);
    }
    currentScope.querySelectorAll('[data-suodatinvalitsin]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
